<app-header></app-header>
<div class="container-fluid">
  @if (fileId) {
    <h2>{{fileId.split("_").slice(2, -1).join(" ")}}</h2>
  }
  <hr>
  <div fxLayout="column">
    <div fxLayout="row" fxLayout.lt-md="column">
      <dt fxFlex="25">Specimen collection protocol:</dt>
      <dd fxFlex="75">
        <app-robust-link [link]="link" [text]="file?.key"></app-robust-link>
      </dd>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column">
      <dt fxFlex="25">Organisation:</dt>
      <dd fxFlex="75">{{file?.universityName}}</dd>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column">
      <dt fxFlex="25">Protocol date:</dt>
      <dd fxFlex="75">{{file?.protocolDate}}</dd>
    </div>
  </div>
  <hr>

  @if (file?.specimens && file?.specimens.length > 0) {
    <h3 style="margin: 20px 0 20px 0;">Related Specimens and Organisms</h3>
  }
  <div class="table-responsive" [hidden]="!file?.specimens || file?.specimens.length == 0">

    <table mat-table matSort matSortDisableClear [dataSource]="dataSource" table-striped style="width: 100%">
      @for (col of display_fields; track col; let i = $index) {
        <ng-container [matColumnDef]=col>
          <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header> {{column_names[i]}} </th>
          @if (col === 'id') {
            <td mat-cell class="table-cell-data" *matCellDef="let item">
              <a [routerLink]="['/specimen', item[col]]" target="_blank">{{item[col]}}</a>
            </td>
          }
          @if (col === 'derivedFrom') {
            <td mat-cell class="table-cell-data" *matCellDef="let item">
              @if (!checkIsArray(item[col])) {
                <a [routerLink]="['/organism', item[col]]" target="_blank">{{item[col]}}</a>
              }
              @if (checkIsArray(item[col])) {
                <ul>
                  @for (parent of item[col]; track parent) {
                    <li>
                      <a [routerLink]="['/specimen', parent]" target="_blank">{{parent}}</a>
                    </li>
                  }
                </ul>
              }
            </td>
          }
          @if (col !== 'id' && col !== 'derivedFrom') {
            <td mat-cell class="table-cell-data" *matCellDef="let item">
              {{item[col]}}
            </td>
          }
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="display_fields"></tr>
      <tr mat-row *matRowDef="let row; columns: display_fields;"></tr>
    </table>
    <mat-paginator pageSize="10"></mat-paginator>
  </div>
</div>
